let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ReHt")).then(() => parcelRequire('5O93a'));